<template>
  <frog-layout :loading="loading" :loading-message="loadingMessage">
    <md-content>
      <div class="container">
        <div class="contents">
          <div class="company">
            <div class="title">
              <gl-sub-text>対象企業</gl-sub-text>
            </div>
            <gl-select-company :company.sync="company" />
          </div>
          <div class="forecasts-container" v-if="0 < forecasts.length">
            <div class="operation">
              <gl-switch v-model="visibleActionOnly" :disabled="maintenance"
                >アクションするものだけ</gl-switch
              >
              <gl-switch v-model="maintenance">メンテンスモード</gl-switch>
              <div gl-tooltip="保存" gl-tooltip-direction="down">
                <gl-button
                  v-if="maintenance"
                  @click="save"
                  icon-button
                  accent
                  icon-pre="save"
                ></gl-button>
              </div>
            </div>

            <div class="download-container" v-if="!maintenance">
              <div class="table-container">
                <md-table
                  v-model="_forecasts"
                  md-card
                  class="table"
                  :disabled="true"
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="状態" class="label-name">{{
                      item.forecastName
                    }}</md-table-cell>
                    <md-table-cell md-label="ID数" class="customer-count">
                      <div
                        class="customer-count-value"
                        @click="donwload(item.forecastId, false)"
                        v-if="item.customerCount > 0"
                      >
                        {{ item.customerCount | formatNumeric('0,0') }}
                      </div>
                    </md-table-cell>
                    <md-table-cell md-label="未抽出ID数" class="not-exported">
                      <div
                        class="not-exported-value"
                        @click="donwload(item.forecastId, true)"
                        v-if="item.notExported > 0"
                      >
                        {{ item.notExported | formatNumeric('0,0') }}
                      </div>
                    </md-table-cell>
                    <md-table-cell md-label="アクション" class="action">
                      <md-icon class="md-accent" v-if="item.needsAction"
                        >star</md-icon
                      >
                    </md-table-cell>
                    <md-table-cell md-label="タグ" class="tags">
                      <md-chips
                        class="md-primary"
                        v-model="item.tags"
                        md-static
                      ></md-chips>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>

            <div class="maintenance-container" v-else>
              <div class="table-container">
                <md-table v-model="_forecasts" md-card class="table">
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    class="md-primary"
                  >
                    <md-table-cell md-label="離反" class="label-name">
                      <md-field md-clearable>
                        <md-input
                          ref="text"
                          type="text"
                          v-model="item.forecastName"
                        />
                      </md-field>
                    </md-table-cell>
                    <md-table-cell md-label="ID数" class="customer-count">
                      {{ item.customerCount | formatNumeric('0,0') }}
                    </md-table-cell>
                    <md-table-cell md-label="未抽出ID数" class="not-exported">
                      {{ item.notExported | formatNumeric('0,0') }}
                    </md-table-cell>
                    <md-table-cell md-label="アクション" class="action">
                      <md-checkbox v-model="item.needsAction"></md-checkbox>
                    </md-table-cell>
                    <md-table-cell md-label="タグ" class="tags">
                      <md-chips
                        class="md-primary"
                        md-deletable
                        v-model="item.tags"
                        :md-limit="3"
                      >
                        <div class="md-helper-text">3つまで。入力してEnter</div>
                      </md-chips>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </div>
          <!-- empty -->
          <div class="empty-container" v-if="forecasts.length == 0 && loaded">
            <md-empty-state
              md-icon="warning"
              md-description="まだデータが作成されていません。"
            ></md-empty-state>
          </div>

          <md-snackbar
            md-position="center"
            :md-duration="snackbar.duration"
            :md-active.sync="snackbar.show"
            md-persistent
          >
            <span>{{ snackbar.message }}</span>
          </md-snackbar>
        </div>
      </div>
    </md-content>
  </frog-layout>
</template>

<script>
import FrogLayout from '@/components/layout/FrogLayout'

export default {
  components: {
    FrogLayout,
  },
  data() {
    return {
      company: undefined,
      forecasts: [],
      visibleActionOnly: true,
      lastVisibleActionOnly: true,
      maintenance: false,
      loaded: false,
      loading: false,
      loadingMessage: '',
      snackbar: {
        show: false,
        duration: 4000,
        message: '',
      },
    }
  },
  methods: {
    // 更新
    async reload() {
      this.loading = true
      this.forecasts = await this.$repositories.get('frog').get(this.company)
      this.loaded = true
      this.loading = false
      this.loadingMessage = '読込中です'
      this.maintenance = false
      this.visibleActionOnly = this.lastVisibleActionOnly
    },
    // 画面情報を保存
    async save() {
      this.forecasts = await this.$repositories
        .get('frog')
        .edit(this.company, this.forecasts)
      this.maintenance = false
      this.snackbar.show = true
      this.snackbar.message = '保存しました'
    },
    // 選択したセルのファイルをダウンロード
    async donwload(id, notExported) {
      this.loading = true
      this.loadingMessage = '取得中です'

      const url = await this.$repositories
        .get('frog')
        .getDownloadUrl(this.company, id, notExported)
      if (url) {
        window.open(url)
        this.reload()
      } else {
        throw new Error('ファイルが作成できませんでした')
      }
      this.loading = false
    },
  },
  computed: {
    _forecasts() {
      if (!this.maintenance && this.visibleActionOnly) {
        return this.forecasts.filter(forecast => forecast.needsAction)
      } else {
        return this.forecasts
      }
    },
  },
  watch: {
    //画面の内容で予報名称の登録を行う
    async maintenance(newval) {
      if (newval) {
        this.lastVisibleActionOnly = this.visibleActionOnly
        this.visibleActionOnly = false
      } else {
        this.visibleActionOnly = this.lastVisibleActionOnly
      }
    },
    company: {
      immediate: true,
      async handler(company) {
        if (company) {
          this.reload()
        }
      },
    },
  },
  async mounted() {},
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contents {
  width: auto;
  max-width: 1000px;
  padding-top: var(--spacing-large);
  padding-bottom: var(--spacing-large);
}
.operation {
  margin-left: var(--spacing-medium);
  display: flex;
  width: calc(100% - 20px);
}
.table-container {
  .table {
    margin-left: var(--spacing-medium);
    width: auto;
    height: calc(100% - 10px);
    max-height: calc(100% - 10px);
  }
}
.md-table-row {
  .label-name {
    width: 300px;
    font-size: var(--font-size-large);
  }
  .tag {
    width: 400px;
  }
  .customer-count,
  .not-exported {
    width: 100px;
    text-align: right;
  }
  .customer-count-value,
  .not-exported-value {
    cursor: pointer;
    color: var(--md-theme-default-primary-on-background, #448aff);
    text-decoration: underline;
    font-size: var(--font-size-large);
  }
  .action {
    width: 10px;
    max-width: 10px;
    text-align: center;
  }
}
</style>
